/* Simplin LLC — header interactions: mobile menu, search overlay with Shopify predictive search.
   Cart behaviour stays with the theme (Ella theme.js, [data-cart-sidebar]). */
(function () {
  'use strict';
  if (window.__swHeaderInit) return;
  window.__swHeaderInit = true;

  var body = document.body;

  // ---- Mobile menu ------------------------------------------------------
  var toggle = document.querySelector('[data-sw-menu-toggle]');
  var mobileNav = document.getElementById('sw-mobile-nav');
  function setMenu(open) {
    if (!toggle || !mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }
  if (toggle) toggle.addEventListener('click', function () { setMenu(!mobileNav.classList.contains('is-open')); });
  window.addEventListener('resize', function () { if (window.innerWidth > 730) setMenu(false); });


  // ---- Hero slider --------------------------------------------------------------
  document.querySelectorAll('[data-sw-slider]').forEach(function (root) {
    var slides = root.querySelectorAll('.sw-hero-slide');
    var dots = root.querySelectorAll('[data-sw-dot]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var pauseBtn = root.querySelector('[data-sw-pause]');
    var paused = false;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (sl, k) {
        var on = k === i;
        sl.classList.toggle('is-active', on);
        sl.setAttribute('aria-hidden', on ? 'false' : 'true');
        sl.querySelectorAll('a, button').forEach(function (el) { if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() { stop(); if (auto && !paused) timer = setInterval(function () { show(i + 1); }, interval); }
    var prev = root.querySelector('[data-sw-prev]'), next = root.querySelector('[data-sw-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-sw-dot'), 10)); start(); }); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused; pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); pauseBtn.textContent = paused ? '\u25B6' : 'II'; if (paused) stop(); else start();
    });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    // Theme editor: jump to the selected slide
    document.addEventListener('shopify:block:select', function (e) {
      var target = e.target && e.target.closest ? e.target.closest('.sw-hero-slide') : null;
      if (target && root.contains(target)) { show(Array.prototype.indexOf.call(slides, target)); stop(); }
    });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) { show(i + (dx < 0 ? 1 : -1)); start(); } x0 = null; });
    start();
  });

  // ---- Search overlay -------------------------------------------------------
  var overlay = document.getElementById('sw-search');
  if (!overlay) return;
  var input = overlay.querySelector('[data-sw-search-input]');
  var results = overlay.querySelector('[data-sw-search-results]');
  var quickLinks = results ? results.innerHTML : '';
  var openers = document.querySelectorAll('[data-sw-search-open]');
  var lastFocus = null;
  var controller = null;
  var timer = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function openSearch() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    overlay.classList.add('is-open');
    body.classList.add('sw-lock');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setMenu(false);
    setTimeout(function () { input && input.focus(); }, 30);
  }
  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    body.classList.remove('sw-lock');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  openers.forEach(function (b) { b.addEventListener('click', openSearch); });
  overlay.querySelectorAll('[data-sw-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSearch(); });
  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSearch(); return; }
    if (e.key === 'Tab') {
      var f = overlay.querySelectorAll('a[href], button, input:not([type="hidden"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function esc(str) { var d = document.createElement('div'); d.textContent = str == null ? '' : String(str); return d.innerHTML; }
  function money(p) {
    if (p == null || p === '') return '';
    var n = Number(p);
    if (isNaN(n)) return esc(p);
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(n); }
    catch (err) { return '$' + n.toFixed(2); }
  }

  function render(data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [], collections = r.collections || [], pages = r.pages || [];
    var html = '';
    if (products.length) {
      html += '<p class="sw-search-label">Products</p>';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="44" height="44">' : '';
        html += '<a class="sw-search-result" href="' + esc(p.url) + '">' + img + '<span class="sw-sr-title">' + esc(p.title) + '</span><span class="sw-sr-meta">' + (p.available === false ? 'Sold out' : money(p.price)) + '</span></a>';
      });
    }
    if (collections.length) {
      html += '<p class="sw-search-label">Categories</p>';
      collections.forEach(function (c) { html += '<a class="sw-search-result" href="' + esc(c.url) + '"><span class="sw-sr-title">' + esc(c.title) + '</span><span class="sw-sr-meta" aria-hidden="true">&#8599;</span></a>'; });
    }
    if (pages.length) {
      html += '<p class="sw-search-label">Pages</p>';
      pages.forEach(function (p) { html += '<a class="sw-search-result" href="' + esc(p.url) + '"><span class="sw-sr-title">' + esc(p.title) + '</span><span class="sw-sr-meta" aria-hidden="true">&#8599;</span></a>'; });
    }
    if (!html) html = '<p class="sw-search-empty">No matches for “' + esc(q) + '”. Press Search to see all results, or try a different term.</p>';
    else html += '<a class="sw-search-result" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last"><span class="sw-sr-title">See all results for “' + esc(q) + '”</span><span class="sw-sr-meta" aria-hidden="true">&#8599;</span></a>';
    results.innerHTML = html;
  }

  function search(q) {
    if (controller) controller.abort();
    if (!q) { results.innerHTML = quickLinks; return; }
    controller = window.AbortController ? new AbortController() : null;
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (data) { if (input.value.trim() === q) render(data, q); })
      .catch(function (err) { if (err && err.name === 'AbortError') return; results.innerHTML = '<p class="sw-search-empty">Suggestions are unavailable right now. Press Search to see results.</p>'; });
  }
  if (input) input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    timer = setTimeout(function () { search(q); }, 220);
  });

  // ---- Keep the header cart badge honest after Ella cart updates -------------------------
  function syncBadge() {
    document.querySelectorAll('.sw-count[data-cart-count]').forEach(function (el) {
      var n = parseInt(el.textContent, 10) || 0;
      el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
      var link = el.closest('a');
      if (link) link.setAttribute('aria-label', 'Cart, ' + n + ' item' + (n === 1 ? '' : 's'));
    });
  }
  document.querySelectorAll('.sw-count[data-cart-count]').forEach(function (el) {
    new MutationObserver(syncBadge).observe(el, { childList: true, characterData: true, subtree: true });
  });
})();
